<div id="wrap" class="scplus">

	<header *ngIf="hasRoute('start')" class="header-main">
		<div class="inner">
			<div class="logo-wrapper"><a href="#" data-ng-click="btnMain()"><img src="./assets/images/logo.png"></a></div>
			<!--h1><a href="#" data-ng-click="btnMain()"><i class="sp img_sclogo">Samsung Care+</i></a></h1>
			<a href="#" class="btn login-btn ng-hide" data-ng-show="vm.ROUTE_VERSION === 'v2'" data-ng-click="on.signIn()">Sign up</a-->
			<div class="txt_wrap ng-scope" data-ng-if="isMain">
				<div class="main-slogan" data-ng-bind-html="'text.main' | translate | htmlSafe">Added Protection and Confidence
					<p>When the unexpected happens, rest easy with Samsung Care+.<br/>From a personal setup session to coverage for mechanical breakdowns and power surges, we'll take care of you every step of the way.</p>
				</div>

			</div>
			<!--div class="visual"></div-->
		</div>
	</header>

	<header *ngIf="!hasRoute('start') && !hasRoute('amazon')" class="header-sub">
		<div class="inner">
			<div class="logo-wrapper"><a href="#" data-ng-click="btnMain()"><img src="./assets/images/logo.png"></a></div>
			<!--h1><a href="#" data-ng-click="btnMain()"><i class="sp img_sclogo">Samsung Care+</i></a></h1>
			<a href="#" class="btn login-btn ng-hide" data-ng-show="vm.ROUTE_VERSION === 'v2'" data-ng-click="on.signIn()">Sign up</a-->
			<div class="txt_wrap ng-scope" data-ng-if="isMain">
				<div class="sub-slogan" data-ng-bind-html="'text.main' | translate | htmlSafe">Added Protection and Confidence</div>
			</div>
			<!--div class="visual"></div-->
		</div>
	</header>
	<!--section data-ui-visual="" class="visual_wrap clearfix ng-scope">

	</section-->
	<router-outlet></router-outlet>
	<footer *ngIf="!hasRoute('amazon')" data-ui-footer="" class="ng-scope footer-wrapper">
		<div class="inner">
				<div class="footer-bottom">
					<div class="footer-left">
						<div class="footer-contact">
							<h3>Contact Us</h3>
							If you have any question or need help with your order,<br/>  please contact us at 866-371-9501
						</div>
					</div>
					<div class="footer-right">
						<ul>
							<li><a href="https://www.samsung.com/us/privacy/" target="_blank" class="btn_cs">Privacy</a></li>
							<li><a href="https://www.samsung.com/us/privacy/ccpa/" target="_blank" class="btn_cs">Do Not Sell My Personal
								Information</a></li>
							<li><a href="https://www.samsung.com/us/common/legal.html" target="_blank" class="btn_cs">Legal</a></li>
						</ul>
						<div class="copyright-text">Copyright © 1995-2021 SAMSUNG. All Rights Reserved.</div>
					</div>
				</div>
			<!--div class="copyright">
				<p>Copyright © 1995-2021 SAMSUNG All Rights Reserved.</p>
			</div>
			<div class="util ng-scope" data-ng-if="('display.footer.area' | translate) != 'false'">
				<a href="https://www.samsung.com/us/privacy/" target="_blank" class="btn_cs">Privacy</a>
				<a href="https://www.samsung.com/us/privacy/ccpa/" target="_blank" class="btn_cs">Do Not Sell My Personal
					Information</a>
				<a href="https://www.samsung.com/us/common/legal.html" target="_blank" class="btn_cs">Legal</a>
			</div-->
			<!-- <div class="util ng-scope" data-ng-if="('display.footer.area' | translate) != 'false'">
				<a data-ng-href="https://www.samsung.com/us/support/" target="_blank" class="btn_cs"
					href="https://www.samsung.com/us/support/"><i class="sp ico_cs"></i>Support<i class="sp ico_pop"></i></a>
				<div class="lang_area">
					<div class="lang_select">
						<label for="ul-id"><button type="button" data-ng-click="on.toggleCountry()" class="ng-binding">SELECT COUNTRY</button></label>
						<ul role="listbox" id="ul-id">
							<li role="option" tabindex="-1"><a href="#" type="button" data-ng-click="on.moveRegion()">CHOOSE OTHER COUNTRY OR REGION</a></li>
						</ul>
					</div>
				</div>
			</div> -->
		</div>
	</footer>
</div>

<script async="" src="https://www.googletagmanager.com/gtag/js?id=UA-128167109-1"></script>
<script>
	smc.gaId = 'UA-128167109-1';
	window.dataLayer = window.dataLayer || [];
	function gtag() {
		dataLayer.push(arguments);
	}
	gtag('js', new Date());
</script>
<div id="smc-loading" class="loading" style="display: none;"><span class="blind">Loading</span></div>
<div id="smc-dimmed" class="dimmed" style="display: none;"></div>
